import React from 'react';
import { IconProps } from '../types';
const MinecraftCrossbowPulling0: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="12" y="0" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="8" y="1" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="9" y="1" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="10" y="1" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="11" y="1" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="12" y="1" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="13" y="1" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(151, 151, 151, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="6" y="2" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="7" y="2" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="8" y="2" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="9" y="2" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="10" y="2" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="11" y="2" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="12" y="2" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="13" y="2" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(151, 151, 151, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(181, 115, 47, 255)" />
<rect x="7" y="3" width="1" height="1" fill="rgba(59, 36, 13, 255)" />
<rect x="8" y="3" width="1" height="1" fill="rgba(59, 36, 13, 255)" />
<rect x="9" y="3" width="1" height="1" fill="rgba(59, 36, 13, 255)" />
<rect x="10" y="3" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="12" y="3" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(181, 115, 47, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(59, 36, 13, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="12" y="4" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(59, 36, 13, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="11" y="5" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(59, 36, 13, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="10" y="6" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(72, 43, 16, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="1" y="8" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="2" y="8" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="1" y="9" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="2" y="9" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="3" y="9" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="1" y="10" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="2" y="10" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(150, 150, 150, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(54, 32, 11, 255)" />
<rect x="1" y="11" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="2" y="11" width="1" height="1" fill="rgba(144, 88, 31, 255)" />
<rect x="5" y="11" width="1" height="1" fill="rgba(109, 109, 109, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="0" y="12" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="1" y="12" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="2" y="12" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="3" y="12" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="4" y="12" width="1" height="1" fill="rgba(68, 68, 68, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(54, 32, 11, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(54, 32, 11, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="1" y="13" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="2" y="13" width="1" height="1" fill="rgba(42, 26, 9, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(54, 32, 11, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(77, 46, 17, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="15" y="13" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(109, 66, 24, 255)" />
<rect x="14" y="14" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="15" y="14" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="13" y="15" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
<rect x="14" y="15" width="1" height="1" fill="rgba(31, 18, 6, 255)" />
</svg>);
export default MinecraftCrossbowPulling0;